// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3PAPb","label":"Category_label__1eX1-","content":"Category_content__1Vpr3","header":"Category_header__3hbNd","location":"Category_location__1t3On"};